import type { Store } from "redux";
import { get } from "lodash";

const reducerRootSelector = "unifiedModules.Account";

export const getAccountModalOpened = (store: Store) =>
  get(store, `${reducerRootSelector}.isOpened`, false);
